import classNames from '@utils/classnames';
import { CalendarDotsIcon, ClockIcon } from '@phosphor-icons/react';

import { OrderLineStopType } from 'src/types/enums';
import { formatDate, formatInputTime } from '../../../../../utils/date';
import { useCreateCreditNoteCtx } from './context';
import { nullthrows } from '../../../../../utils/invariant';
import { useOrders } from '../../../../order/models';
import { DelayedSpinner } from 'components/Spinner';

export interface Props {
  searchValue: string;
}

export const OrderSelect: React.FC<Props> = (props) => {
  const { searchValue } = props;
  const { state, dispatch } = useCreateCreditNoteCtx();
  const invoice = nullthrows(state.selectedInvoice, 'No orders selected');
  const { data, isLoading } = useOrders({
    filters: {
      invoiceId: invoice.id,
      orderNumber: searchValue || undefined,
    },
    orderBy: {
      orderNumber: 'asc',
    },
  });
  const orders = data?.orders ?? [];

  if (isLoading) {
    return <DelayedSpinner size={8} className="flex justify-center items-center mt-8" />;
  }
  const selectedOrderIds = new Set(state.orders.map((o) => o.id));

  return (
    <div className="grid gap-4 lg:grid-cols-2 2xl:grid-cols-3">
      {!orders.length && <div>Geen orders gevonden</div>}

      {orders.map((o) => {
        const isSelected = selectedOrderIds.has(o.id);
        return (
          <div
            key={o.id}
            className={classNames('card p-4', {
              'selected-card': isSelected,
            })}
            data-clickable="true"
            onClick={() => {
              dispatch({
                type: 'SELECT_ORDER',
                order: o,
              });
            }}
          >
            <div className="card-heading-text">{o.orderNumber}</div>

            {o.lines.map((line) => {
              return (
                <div>
                  {line.stops
                    .sort((a, b) => a.sequenceIndex - b.sequenceIndex)
                    .map((stop) => {
                      return (
                        <div className="grid grid-cols-2 my-1">
                          <div className="font-medium">{stop.type === OrderLineStopType.Load ? 'Laden' : 'Lossen'}</div>
                          <div>
                            {stop.location.country}-{stop.location.name}
                          </div>

                          <div className="flex gap-2 items-center">
                            <CalendarDotsIcon className="w-4 h-4" />
                            {formatDate(stop.date)}
                          </div>
                          <div className="flex gap-2 items-center">
                            <ClockIcon className="w-4 h-4" />
                            {`${formatInputTime(stop.timeStart)}-${formatInputTime(stop.timeEnd)}`}
                          </div>
                        </div>
                      );
                    })}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};
